<template>
  <div>
    <v-btn class="mx-2 sound" fab dark large fixed right bottom>
      <v-icon dark> mdi-volume-high </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "FloatingButton"
};
</script>

<style lang="scss" scoped></style>
